<div class="container padding-top-10 padding-bottom-10 ocorrencia-maquina">
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <div class='btn-toolbar pull-right'>
          <div class='btn-group'>
            <a class="btn btn-primary btn-sm btn-action" href="#!/ocorrencias_maquinas/new" uib-tooltip="Nova Ocorrência" tooltip-placement="left" ng-if="permissions.maquina.canManage">
              Novo <i class="fa fa-plus"></i>
            </a>
          </div>
        </div>
        <h2>Ocorrências de Máquinas</h2>
      </div>
    </div>
  </div>

  <div class="row" ng-include="'views/ocorrencias_maquinas/_filtros.html'"></div>
  <div class="row" ng-include="'views/ocorrencias_maquinas/_list.html'"></div>
</div>